import router from './router'
import usePersonnelStore from './store'
import PersonnelMessages from './localization'

export default {
  router,
  usePersonnelStore,
  localization: PersonnelMessages,
}
